import styled from "styled-components";

const StyledMatchButtonStreamer = styled.div`
  width: 100%;
`;

const StyledMatchButtonStreamerWrapper = styled.div`
  width: 100%;
  .mls-match-button-wrapper {
    &.--canc,
    &.--ppd,
    &.--aban {
      height: ${(props) => props.theme.figma.base.scale_4_50}px;
    }
  }
`;
export { StyledMatchButtonStreamer, StyledMatchButtonStreamerWrapper };
